module.exports = __webpack_public_path__ + "static/media/bison-burger-en.e04cc7cd.jpg";